import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export default React.memo(props => (
  <SvgIcon {...props} width="16" height="16" viewBox="0 0 16 16" fill="none">
    <g clipPath="url(#clip0_686_2068)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.99998 1.83337C4.59423 1.83337 1.83331 4.59429 1.83331 8.00004C1.83331 11.4058 4.59423 14.1667 7.99998 14.1667C11.4058 14.1667 14.1666 11.4058 14.1666 8.00004C14.1666 4.59429 11.4058 1.83337 7.99998 1.83337ZM0.833313 8.00004C0.833313 4.042 4.04194 0.833374 7.99998 0.833374C11.9581 0.833374 15.1666 4.04201 15.1666 8.00004C15.1666 11.9581 11.9581 15.1667 7.99998 15.1667C4.04194 15.1667 0.833313 11.9581 0.833313 8.00004Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.92591 5.83337C5.87477 5.83337 5.83331 5.87483 5.83331 5.92597V10.0741C5.83331 10.1253 5.87477 10.1667 5.92591 10.1667H10.0741C10.1252 10.1667 10.1666 10.1253 10.1666 10.0741V5.92597C10.1666 5.87483 10.1252 5.83337 10.0741 5.83337H5.92591ZM4.83331 5.92597C4.83331 5.32254 5.32248 4.83337 5.92591 4.83337H10.0741C10.6775 4.83337 11.1666 5.32254 11.1666 5.92597V10.0741C11.1666 10.6775 10.6775 11.1667 10.0741 11.1667H5.92591C5.32248 11.1667 4.83331 10.6775 4.83331 10.0741V5.92597Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.83331 7.33337C4.83331 7.05723 5.05717 6.83337 5.33331 6.83337H10.6666C10.9428 6.83337 11.1666 7.05723 11.1666 7.33337C11.1666 7.60952 10.9428 7.83337 10.6666 7.83337H5.33331C5.05717 7.83337 4.83331 7.60952 4.83331 7.33337Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.33331 6.83337C7.60946 6.83337 7.83331 7.05723 7.83331 7.33337V10.6667C7.83331 10.9428 7.60946 11.1667 7.33331 11.1667C7.05717 11.1667 6.83331 10.9428 6.83331 10.6667V7.33337C6.83331 7.05723 7.05717 6.83337 7.33331 6.83337Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_686_2068">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </SvgIcon>
));
